import { useQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { getCurrentOrg } from "../util/org.util";
import { ZoomAccountQueryDocument } from "./__generated__/Zoom.generated";

export const useZoomAccount = () => {
  const { loading, data } = useQuery(ZoomAccountQueryDocument);

  const org = getCurrentOrg(data?.viewer);
  const orgAccount = getValue(org?.zoomAccount);
  const userAccount = getValue(org?.zoomUserLevelAccount);

  const account = userAccount || orgAccount;
  const enabled = !!userAccount || !!(orgAccount && orgAccount.hasValidZoomAccount);

  return { account, userAccount, orgAccount, enabled, loading };
};
